import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess40600Status: 'idle',
    startProcess40600Error: undefined as any,
    loadUserParamsProcess40600Status: 'idle',
    loadUserParamsProcess40600Error: undefined as any,

    process40600List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess40600 = createAsyncThunk('process40600Slice/startProcess40600', async ({ process40600 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess40600/`,
        prepareData(process40600),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess40600Status } = getState().process40600Slice
        return startProcess40600Status !== 'pending'
    }
})

export const loadUserParamsProcess40600 = createAsyncThunk('process40600Slice/loadUserParamsProcess40600', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess40600/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess40600Status } = getState().process40600Slice
        return loadUserParamsProcess40600Status !== 'pending'
    }
})

const Process40600Slice = createSlice({
    name: 'process40600Slice',
    initialState,
    reducers: {
        resetstartProcess40600: (state) => {
            state.job = undefined
            state.startProcess40600Error = undefined
        },
        resetstartProcess40600Error: (state) => {
            state.startProcess40600Error = undefined
        },
        resetloadUserParamsProcess40600: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess40600Error = undefined
        },
        resetloadUserParamsProcess40600Error: (state) => {
            state.loadUserParamsProcess40600Error = undefined
        },
        removeFromProcess40600ListById: (state, action) => {
            state.process40600List = state.process40600List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess40600ListByIds: (state, action) => {
            state.process40600List = state.process40600List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process40600List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess40600Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process40600List = []
            state.startProcess40600Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess40600.pending, (state) => {
            state.startProcess40600Status = 'pending'
            state.startProcess40600Error = undefined
        })
        builder.addCase(startProcess40600.fulfilled, (state, action) => {
            state.startProcess40600Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess40600.rejected, (state, action) => {
            state.startProcess40600Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess40600Error = action.error.message
            } else {
                state.startProcess40600Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess40600.pending, (state) => {
            state.loadUserParamsProcess40600Status = 'pending'
            state.loadUserParamsProcess40600Error = undefined
        })
        builder.addCase(loadUserParamsProcess40600.fulfilled, (state, action) => {
            state.loadUserParamsProcess40600Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess40600.rejected, (state, action) => {
            state.loadUserParamsProcess40600Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess40600Error = action.error.message
            } else {
                state.loadUserParamsProcess40600Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess40600,
    resetstartProcess40600Error,
    resetloadUserParamsProcess40600,
    resetloadUserParamsProcess40600Error,
    removeFromProcess40600ListById,
    removeFromProcess40600ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process40600Slice.actions
export default Process40600Slice.reducer
